webpackJsonp([27],{

/***/ 1506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileRegisterInstructionNorsk_vue__ = __webpack_require__(1770);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55044d54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileRegisterInstructionNorsk_vue__ = __webpack_require__(1877);
function injectStyle (ssrContext) {
  __webpack_require__(1875)
}
var normalizeComponent = __webpack_require__(948)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55044d54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileRegisterInstructionNorsk_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55044d54_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileRegisterInstructionNorsk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo.a7b8e63.svg";

/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/TransparencyLogo.9957347.svg";

/***/ }),

/***/ 1706:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/MainScreen.7fc4328.jpeg";

/***/ }),

/***/ 1707:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/InvitationCode.278d6e2.png";

/***/ }),

/***/ 1708:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Informations.32accba.png";

/***/ }),

/***/ 1709:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Success.f57330e.png";

/***/ }),

/***/ 1770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 1875:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1876);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1498)("7cec2d46", content, true, {});

/***/ }),

/***/ 1876:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1497)(true);
// imports


// module
exports.push([module.i, ".top-logo-bar[data-v-55044d54]{width:100%;height:100px;background:#347c93}.section-header[data-v-55044d54]{margin-bottom:20px;margin-top:40px;font-weight:600;font-size:24px}.main-header[data-v-55044d54]{font-weight:700;font-size:32px;margin-top:20px}section[data-v-55044d54]{padding-right:40vw}p[data-v-55044d54]{text-align:justify}li[data-v-55044d54]{font-weight:700}.policy-container[data-v-55044d54]{height:calc(100% - 100px);overflow-y:scroll;padding-left:calc(15vw + 30px)}@media only screen and (max-width:700px){.policy-container[data-v-55044d54]{padding-left:5%}section[data-v-55044d54]{padding-right:5%}}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/MobileRegisterInstructionNorsk.vue"],"names":[],"mappings":"AACA,+BACI,WAAY,AACZ,aAAc,AACd,kBAAoB,CACvB,AACD,iCACI,mBAAoB,AACpB,gBAAiB,AACjB,gBAAiB,AACjB,cAAgB,CACnB,AACD,8BACI,gBAAiB,AACjB,eAAgB,AAChB,eAAiB,CACpB,AACD,yBACI,kBAAoB,CACvB,AACD,mBACI,kBAAoB,CAEvB,AACD,oBACI,eAAiB,CACpB,AACD,mCACI,0BAA2B,AAC3B,kBAAmB,AACnB,8BAAgC,CACnC,AACD,yCACA,mCACQ,eAAiB,CACxB,AACD,yBACQ,gBAAkB,CACzB,CACA","file":"MobileRegisterInstructionNorsk.vue","sourcesContent":["\n.top-logo-bar[data-v-55044d54] {\n    width: 100%;\n    height: 100px;\n    background: #347C93;\n}\n.section-header[data-v-55044d54] {\n    margin-bottom: 20px;\n    margin-top: 40px;\n    font-weight: 600;\n    font-size: 24px;\n}\n.main-header[data-v-55044d54] {\n    font-weight: 700;\n    font-size: 32px;\n    margin-top: 20px;\n}\nsection[data-v-55044d54] {\n    padding-right: 40vw;\n}\np[data-v-55044d54] {\n    text-align: justify;\n    /* margin-left: 2vw; */\n}\nli[data-v-55044d54] {\n    font-weight: 700;\n}\n.policy-container[data-v-55044d54] {\n    height: calc(100% - 100px); \n    overflow-y: scroll; \n    padding-left: calc(15vw + 30px);\n}\n@media only screen and (max-width: 700px) {\n.policy-container[data-v-55044d54] {\n        padding-left: 5%;\n}\nsection[data-v-55044d54] {\n        padding-right: 5%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"top-logo-bar",staticStyle:{"display":"flex","align-items":"center"}},[_c('router-link',{staticStyle:{"align-items":"left","display":"flex"},attrs:{"to":{name: 'login'}}},[_c('img',{staticClass:"app-logo",staticStyle:{"margin-left":"10vw","height":"35px","margin-top":"0px","padding-right":"20px","border-right":"1px solid #AEAEAE7F"},attrs:{"src":__webpack_require__(1590)}}),_vm._v(" "),_c('img',{staticClass:"app-logo",staticStyle:{"margin-left":"20px","height":"35px","margin-top":"0px"},attrs:{"src":__webpack_require__(1656)}})])],1)]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"policy-container"},[_c('div',{staticClass:"main-header"},[_vm._v("Registrer deg i mobilappen")]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"30px"}},[_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("1. Last ned CRFI+-applikasjonen til mobilen din")]),_vm._v(" "),_c('a',{staticStyle:{"display":"inline-block","overflow":"hidden"},attrs:{"href":"https://play.google.com/store/apps/details?id=com.biocontrol.crfi_monitor&pcampaignid=web_share&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"}},[_c('img',{staticStyle:{"height":"65px","object-fit":"contain"},attrs:{"alt":"Get it on Google Play","src":"https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"}})]),_vm._v(" "),_c('a',{staticStyle:{"display":"inline-block","overflow":"hidden","padding":"10px"},attrs:{"href":"https://apps.apple.com/us/app/crfi/id6445917147?itsct=apps_box_badge&itscg=30200"}},[_c('img',{staticStyle:{"height":"45px","object-fit":"contain"},attrs:{"src":"https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1658707200","alt":"Download on the App Store"}})])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("2. Åpne appen")])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("3. Klikk på \"Registrer\" nederst i høyre hjørne.")]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center"}},[_c('img',{staticStyle:{"height":"450px"},attrs:{"src":__webpack_require__(1706)}})])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("4. Fyll ut registrering med e-postadressen din (som du fikk e-post med invitasjonskode til) og invitasjonskoden tilsvarende. "),_c('br'),_vm._v(" Klikk på \"Bekreft\" for å sjekke om invitasjonskoden og e-postadressen stemmer overens.")]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center"}},[_c('img',{staticStyle:{"height":"450px"},attrs:{"src":__webpack_require__(1707)}})])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("5. Fyll ut informasjon om kontoen din.")]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center"}},[_c('img',{staticStyle:{"height":"450px"},attrs:{"src":__webpack_require__(1708)}})])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"section-header"},[_vm._v("6. Vellyket. Nå kan du logge inn.")]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center"}},[_c('img',{staticStyle:{"height":"450px"},attrs:{"src":__webpack_require__(1709)}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/27.1b917123515c6dfbcdd0.js